import script from "./MakePaymentContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./MakePaymentContainer.vue?vue&type=script&setup=true&lang=js"

import "./MakePaymentContainer.vue?vue&type=style&index=0&id=67e0a276&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67e0a276"]])

export default __exports__